import {connectRouter} from 'connected-react-router';
import {combineReducers} from 'redux';

import authReducer from './auth';
import configReducer from './config';
import errorsReducer from './errors';
import successMessagesReducer from './success';

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    config: configReducer,
    errors: errorsReducer,
    successMessages: successMessagesReducer,
  });

export default createRootReducer;
